import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import HighlightProxy from './HighlightProxy'

class HightLightService extends ServiceBase {
  getRiskScaleInterpretation(params) {
    return this.getData(() => HighlightProxy.getRiskScaleInterpretation(params))
  }

  getIndustryMedianRiskScore(params) {
    return this.getData(() => HighlightProxy.getIndustryMedianRiskScore(params))
  }

  financialRatioHighlight(params) {
    return this.getData(() => HighlightProxy.financialRatioHighlight(params))
  }
}

export default new HightLightService()
